import { Component, EventEmitter, Input, Output } from '@angular/core';
import { HeaderPromotionComponent } from '../header-promotion/header-promotion.component';
import { CommonModule, NgIf, NgClass } from '@angular/common';
import { RouterLink } from '@angular/router';
import { headerSetting } from 'src/_lib/interfaces/homepagesettings.interface';
import { AppConstants } from 'src/app/app.constants';
import { environment } from 'src/environments/environment.prod';
import { HeaderCartSectionComponent } from '../header-cart-section/header-cart-section.component';
import { ShoppingCartComponent } from '../header-cart-section/shopping-cart/shopping-cart.component';
import { HeaderContactUsSectionComponent } from '../header-contact-us-section/header-contact-us-section.component';
import { HeaderLogoComponent } from '../header-logo/header-logo.component';
import { HeaderMobileMenuComponent } from '../header-mobile-menu/header-mobile-menu.component';
import { HeaderMyGarageSectionComponent } from '../header-my-garage-section/header-my-garage-section.component';
import { HeaderNavComponent } from '../header-nav/header-nav.component';
import { HeaderSearchComponent } from '../header-search/header-search.component';
import { HeaderSidebarMenuComponent } from '../header-sidebar-menu/header-sidebar-menu.component';
import { HeaderThirdRowComponent } from '../header-third-row/header-third-row.component';
import { ShopByVehicleComponent } from 'src/app/templates/shop-by-vehicle-btn/shop-by-vehicle.component';

@Component({
  selector: 'app-header-ch7',
  templateUrl: './header-ch7.component.html',
  styleUrls: ['./header-ch7.component.scss'],
standalone: true,
   imports: [
      HeaderPromotionComponent,
      HeaderNavComponent,
      HeaderLogoComponent,
      HeaderMobileMenuComponent,
      HeaderContactUsSectionComponent,
      HeaderSearchComponent,
      HeaderCartSectionComponent,
      HeaderSidebarMenuComponent,
      ShoppingCartComponent,
      CommonModule,
      RouterLink,
      NgIf,
      NgClass,
      HeaderThirdRowComponent,
      HeaderMyGarageSectionComponent,
      ShopByVehicleComponent
    ]
})
export class HeaderCh7Component {
cdnImagePath: string = environment.cdnImagePath;
  showdowntooltip: boolean = true;
  isSidebarOpen: boolean;
  firstObj: number = this.appConstants.firstObj;

  @Input() headerSettings: headerSetting<string> = null;
  @Input() custom_ticker: any;
  @Input() isMobile: boolean;
  @Input() headerdata: any;
  @Input() isWishlist: boolean;
  @Input() isSticky: boolean;
  @Input() showSecondRowHeader: boolean;
  @Input() showFirstRowHeader: boolean;
   @Input() showThirdRowHeader: boolean;
  @Input() showLogo: boolean;
  @Input() showCart: boolean;
  @Input() isSearchByVehicleDisabled: boolean = false;
  @Output() scrollToTop = new EventEmitter<void>();

  onButtonClick() {
    this.scrollToTop.emit();
  }

  constructor(
    private appConstants: AppConstants
  ) { }

  onSidebarStateChange(state: boolean) {
    this.isSidebarOpen = state;
  }
}

